// extracted by mini-css-extract-plugin
module.exports = {"form":"forgottenPassword-d47a1b60f47a5d6f","submitButton":"forgottenPassword-b52c0c6a650c77b8"};